/* Year/Make/Engine picker wiring. Initializes every [data-sds-ymm] form on the
   page (homepage selector + the site-wide header vehicle bar). Depends on
   window.SDS_VEHICLES (sds-vehicle-data.js) and window.SDSVehicle
   (sds-vehicle-memory.js). Extracted from sds-ymm-selector.liquid so one copy
   serves both. */
(function () {
  function init() {
    if (!window.SDS_VEHICLES) { setTimeout(init, 60); return; }
    document.querySelectorAll('[data-sds-ymm]:not([data-ymm-ready])').forEach(function (form) {
      form.setAttribute('data-ymm-ready', '1');
      var makes = window.SDS_VEHICLES.makes;
      var selMake = form.querySelector('[data-ymm-make]');
      var selYear = form.querySelector('[data-ymm-year]');
      var selEngine = form.querySelector('[data-ymm-engine]');
      var btn = form.querySelector('button[type="submit"]');
      var nowYear = new Date().getFullYear();

      function reset(sel, label) {
        sel.innerHTML = '';
        var o = document.createElement('option');
        o.value = '';
        o.textContent = label;
        sel.appendChild(o);
        sel.disabled = true;
      }

      function endOf(g) { return g.end === null ? nowYear : g.end; }

      var minY = Infinity, maxY = -Infinity;
      makes.forEach(function (m) {
        m.gens.forEach(function (g) {
          if (g.start < minY) minY = g.start;
          if (endOf(g) > maxY) maxY = endOf(g);
        });
      });
      for (var y = maxY; y >= minY; y--) {
        var yo = document.createElement('option');
        yo.value = y;
        yo.textContent = y;
        selYear.appendChild(yo);
      }

      function makesForYear(y) {
        var out = [];
        makes.forEach(function (m, i) {
          var hit = m.gens.some(function (g) { return y >= g.start && y <= endOf(g); });
          if (hit) out.push(i);
        });
        return out;
      }

      selYear.addEventListener('change', function () {
        reset(selMake, 'Make');
        reset(selEngine, 'Engine');
        btn.disabled = true;
        if (selYear.value === '') return;
        var y = parseInt(selYear.value, 10);
        makesForYear(y).forEach(function (i) {
          var o = document.createElement('option');
          o.value = i;
          o.textContent = makes[i].name;
          selMake.appendChild(o);
        });
        selMake.disabled = false;
      });

      selMake.addEventListener('change', function () {
        reset(selEngine, 'Engine');
        btn.disabled = true;
        if (selMake.value === '' || selYear.value === '') return;
        var y = parseInt(selYear.value, 10);
        makes[selMake.value].gens.forEach(function (g, i) {
          if (y >= g.start && y <= endOf(g)) {
            var o = document.createElement('option');
            o.value = i;
            o.textContent = g.engine + ' (' + g.years + ')';
            selEngine.appendChild(o);
          }
        });
        selEngine.disabled = false;
        if (selEngine.options.length === 2) {
          selEngine.selectedIndex = 1;
          btn.disabled = false;
        }
      });

      selEngine.addEventListener('change', function () {
        btn.disabled = selEngine.value === '';
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (selEngine.value === '') return;
        var g = makes[selMake.value].gens[selEngine.value];
        if (!g) return;
        var url = '/collections/' + g.handle;
        if (window.SDSVehicle) {
          var label = selYear.value + ' ' + makes[selMake.value].name + ' ' + g.engine;
          window.SDSVehicle.set(label, url, g.handle);
        }
        window.location.href = url;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
